<template>
  <span :class="[className, 'pokemon-type-' + PokemonTypes[id]]" @click="goPokemonList($event, PokemonTypes[id])">
    {{PokemonTypes[id]}}
  </span>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  name: 'pokemonType',
  props: {
    'id': String,
    'large': Boolean,
    'small': Boolean,
    'power': Number,
  },
  data() {
    return {}
  },
  computed: {
    className() {
      return this.large ? 'pokemon-type-large' : (this.small ? 'pokemon-type-small' : 'pokemon-type') + (this.power ? ' eff-' + this.power : '')
    },
    ...mapGetters({
      PokemonTypes: 'pokemon/types',
    })
  },
  methods: {
    goPokemonList($event, type) {
      $event.stopPropagation()
      this['pokemon/listPageSetFilter']({key: 'type', value: type})
      this.$router.push('/pokemon/list')
    },
    ...mapActions([
      'pokemon/listPageSetFilter',
    ])
  }
}
</script>
